import { graphql } from "relay-runtime"

export const deDuplicatePatientByIdQuery = graphql`
  query deDuplicatePatientByIdQuery($patientId: ID!) {
    de_patientById(id: $patientId) {
      id
      firstName
      lastName
      gender
      displayId
      contactChannel
      country
      duplicatePatients {
        id
        firstName
        lastName
        gender
        displayId
        contactChannel
      }
    }
  }
`
